import type { UserInfoType } from "@/types/user";
import type { Dictionary } from "lodash";

export class PvpCardGameProfile {
  userId = 0;
  exp = 0;
  mmr = 0;
  user: UserInfoType = {} as UserInfoType;
  freeCardPackTime = "";
  winsCardPackCount = 0;
  winCardPackTime = "";
  cardInventory: any[] = [];
  cardDecks: any[] = [];
  pendingCardPack: any[] = [];
  currentCardDeckIndex: number = 0;
  mmrParser: MmrParserType = new MmrParserType();
  passedStages: number[] = [];
  stamina: number = 0;
  staminaUpdatedAt = "";
}
class MmrParserType {
  name: string = "";
  className: string = "";
  value: number = 0;
}

export class DeckResult {
  coin: number = 0;
  diamond: number = 0;
  cardIds: Dictionary<number> = {};
}
